import { render } from "./edit.vue?vue&type=template&id=13fe92d8&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=13fe92d8&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fe92d8"],['__file',"src/views/ticket/tag/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13fe92d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13fe92d8', __exports__)) {
    console.log('reload')
    api.reload('13fe92d8', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=13fe92d8&scoped=true", () => {
    console.log('re-render')
    api.rerender('13fe92d8', render)
  })

}


export default __exports__